import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="uploads"
export default class extends Controller {
  static targets = ["filename","file-label"]
  connect() {




  }

  async fileChange(event) {
    console.log("yes")

    var fileName = '';

    if (event.target.files && event.target.files.length > 1) {
      fileName = (event.target.getAttribute('data-multiple-caption') || '').replace('{count}', event.target.files.length);
    }

    else {
      fileName = event.target.value.split('\\').pop();
    }


    if (fileName) {
      this.filenameTarget.innerHTML = fileName;
    }
    else {
      this.fileLabelTarget.innerHTML = fileName;
    }
  }
}
